import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M49.994 5c-8.551-.023-17.097 2.462-24.286 7.096l24.314 9.838 24.274-9.822C67.105 7.469 58.551 4.977 49.995 5zm28.635 10.277-15.81 17.092q12.519 20.258 25.035 40.515c3.68-2.2 3.978-7.653 5.655-11.374 4.519-16.541-1.466-35.488-14.881-46.233zm-57.397.1C8.543 25.614 2.601 43.076 5.896 58.98c1.046 4.537 3.146 12.255 6.12 13.875Q24.19 52.613 36.362 32.37L21.23 15.376zM50.021 51.22 14.41 77.515c10.905 14.454 31.02 21.04 48.323 15.576 8.988-2.655 17.212-8.087 22.859-15.605L50.021 51.22z" })
});
export default SvgXbox;
